exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-list__container__2zTvT{position:relative;width:100%;height:100%}.page-list__container__2zTvT,.page-list__page__t5R9x{display:-ms-flexbox;display:flex}.page-list__page__t5R9x{-ms-flex-line-pack:start;align-content:flex-start;-ms-flex-wrap:wrap;flex-wrap:wrap}", ""]);

// exports
exports.locals = {
	"container": "page-list__container__2zTvT",
	"page": "page-list__page__t5R9x"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/page-list/page-list.styl
// module id = 2916
// module chunks = 1